import { SessionView } from "admin/src/server/mappers/session/session";
import { profileHasTags } from "admin/src/utils/helpers/profileHasTags";

import { FunctionFactory } from "survey-core";

export const registerTagIncludesExpression = (session: SessionView) => {
  const tagIncludesExpression = (tags: string[]): boolean => {
    return profileHasTags(tags, session);
  };

  FunctionFactory.Instance.register("tag_includes", tagIncludesExpression);
};
